/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Perks_Unit_Active_MinutesInputs */



/**
* | output |
* | --- |
* | "minutes with a message" |
*
* @param {Perks_Unit_Active_MinutesInputs} inputs
* @param {{ locale?: "en" | "ru" }} options
* @returns {LocalizedString}
*/
export const perks_unit_active_minutes = /** @type {((inputs?: Perks_Unit_Active_MinutesInputs, options?: { locale?: "en" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Perks_Unit_Active_MinutesInputs, { locale?: "en" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ru") return /** @type {LocalizedString} */ ("минут с сообщениями")
	return /** @type {LocalizedString} */ ("minutes with a message")
});